var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.number)+" "+_vm._s(_vm.label)+_vm._s(_vm.number > 1 ? _vm.plural : ''))])
}
var staticRenderFns = []

export { render, staticRenderFns }